// extracted by mini-css-extract-plugin
export default {"section":"About_section__aCPnE","title":"About_title__anBG0","card":"About_card__bNFO+","iconWrapper":"About_iconWrapper__I+skA"};